import { useEffect, useState } from 'react'
import { safeLocalStorage } from 'ui'
import { printError } from '~/utils/printError'

import { ErrorTypes } from './constants'

const useHandleError = (error) => {
  const [showDefaultErrBoundary, setShowDefaultErrBoundary] = useState(true)

  useEffect(() => {
    if (error instanceof Error && typeof window !== 'undefined') {
      if (
        (error?.message === ErrorTypes.FAILED_TO_FETCH ||
          error?.message === ErrorTypes.LOAD_FAILED) &&
        typeof localStorage !== 'undefined'
      ) {
        printError(error, 'FETCHERROR')
        safeLocalStorage?.setItem('reload', 'true')
        setShowDefaultErrBoundary(false)
        location?.reload()
      }
    }
  }, [error])

  return showDefaultErrBoundary
}

export default useHandleError
